import { FC, useEffect } from 'react'
import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material'

import { AnalyticsEvent } from 'utils/analytics/AnalyticsEvent'
import { MUIButton } from 'components/common/MUIButton'
import Modal from 'components/common/Modals/Modal/Modal'
import { logAnalyticsEvent } from 'utils/analytics/analyticsUtils'
import { useTranslation } from 'react-i18next'

interface Props {
  isOpen: boolean
  onClose: () => void
}

export const PhotoStudioUnsupportedModal: FC<Props> = ({ isOpen, onClose }) => {
  const { t } = useTranslation(['photo_studio_editing', 'common'])
  const theme = useTheme()
  const isMobileOrSmallTablet = useMediaQuery(theme.breakpoints.down('md'))

  // Log analytics when modal is opened to track usage of unsupported device for Photo Studio
  useEffect(() => {
    if (isOpen) {
      logAnalyticsEvent(AnalyticsEvent.PHOTO_STUDIO_UNSUPPORTED_DEVICE_MODAL_OPENED, {
        timestamp: new Date().toISOString(),
        isMobileOrSmallTablet
      })
    }
  }, [isOpen, isMobileOrSmallTablet])

  return (
    <Modal
      isOpen={isOpen}
      onClickOutside={onClose}
      onKeyDown={(e) => {
        if (e.key === 'Escape') onClose()
      }}
      modalContentClassName={isMobileOrSmallTablet ? 'modal-content-mobile-small' : ''} // You might need to define this class in a global style or pass it down
      footerContent={
        <Stack flexDirection="row" justifyContent="flex-end" alignItems="center" gap=".8rem" padding="1.2rem 1.6rem">
          <MUIButton
            size="lg"
            type="secondaryNoBorder"
            onClick={onClose}
          >
            {t('actions:Cancel')}
          </MUIButton>
        </Stack>
      }
    >
      <Stack padding={isMobileOrSmallTablet ? '1.6rem' : '2.4rem'}>
        <Typography variant={isMobileOrSmallTablet ? 'h4' : 'h3'} textAlign="center">
          {t('photo_studio_editing:unsupported_device_title')}
        </Typography>
        <Typography variant="text-xs" textAlign="center" marginTop={isMobileOrSmallTablet ? '1.2rem' : '1.6rem'}>
          {t('photo_studio_editing:unsupported_device_message')}
        </Typography>
      </Stack>
    </Modal>
  )
}
